import { render, staticRenderFns } from "./visual-type-builder.vue?vue&type=template&id=3e577ed6"
import script from "./visual-type-builder.vue?vue&type=script&lang=js"
export * from "./visual-type-builder.vue?vue&type=script&lang=js"
import style0 from "./visual-type-builder.vue?vue&type=style&index=0&id=3e577ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports